import { render, staticRenderFns } from "./appointmentCard.vue?vue&type=template&id=25af269e&scoped=true"
import script from "./appointmentCard.vue?vue&type=script&lang=ts"
export * from "./appointmentCard.vue?vue&type=script&lang=ts"
import style0 from "./appointmentCard.vue?vue&type=style&index=0&id=25af269e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25af269e",
  null
  
)

export default component.exports